$(document).ready(function(){
  var bullets = $('.health-bullets__list-bullet');

  $(bullets).each(function(i, bullet) {
    $(bullet).on('click', function() {
      var bulletExpand = $(bullet).find('.expand');

      $('.expand').each(function(index, expand) {
        if(i !== index) {
          $(expand).addClass('hide-expand');
        }
      });

      $(bullets).each(function(j, b) {
        if(i !== j) {
          $(b).removeClass('hide-icon');
        }
      });

      $(bulletExpand).toggleClass('hide-expand');
      $(bullet).toggleClass('hide-icon');
    });
  });
});